import React from "react";
import Icon from "../../../components/AppIcon";
import { useTranslation } from "react-i18next";

const CompanyLogo = () => {
  const { t } = useTranslation();
  return (
    <div className="text-center mb-8">
      {/* Logo Icon */}
      <div className="inline-flex items-center justify-center w-16 h-16  mb-4">
        <img src="/images/logo.png" />
      </div>

      {/* Company Name */}
      <h1 className="text-2xl font-bold text-foreground mb-2">
        {t("e_commerce_dashboard")}
      </h1>
    </div>
  );
};

export default CompanyLogo;
